/**
 * Notification Permissions
 *
 * Permissions for sending push notifications
 */

enum NotificationPermission {
  // Send notifications to specific users
  Prem_Notification_Send = 'Prem_Notification_Send',
  // Send notifications to all users
  Prem_Notification_SendAll = 'Prem_Notification_SendAll',
}

export default NotificationPermission;
